<template>
  <v-carousel class="home-page-banner">
    <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
    ></v-carousel-item>
  </v-carousel>
</template>
<script>
export default {
  name: 'BannersSlider',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="scss">
.home-page-banner {
  border-radius: 15px;
  border: 2px solid #FFFFFF;

  & .v-window__prev, & .v-window__next {
    display: none;
  }

  &:hover .v-window__prev, &:hover .v-window__next {
    display: block;
  }

  & .v-carousel__controls {
    background-color: #FFFFFF;
    border-top-left-radius: 15px;
    width: unset;
    right: 0!important;

    & .v-btn {
      color: #ADD4CC;
    }

    & .v-btn--active {
      color: #009357;
    }
  }
}
</style>
